import { Input, InputProps } from '@chakra-ui/react';
import { forwardRef } from 'react';

type Props = {
  isPassword?: boolean;
} & InputProps;

export const CmInput = forwardRef<HTMLInputElement, Props>(
  ({ isPassword = false, ...rest }, ref) => {
    return isPassword ? (
      // @ts-ignore TS2590
      <Input ref={ref} {...rest} type="password" />
    ) : (
      // @ts-ignore TS2590
      <Input ref={ref} {...rest} />
    );
  }
);

CmInput.displayName = 'CmInput';
